import { useState } from 'react'
import i18n from 'translations/i18n'
import {
  useAddComment,
  useMarkAnnouncementAsRead,
} from 'apis/OrgManagement/announcementSegrigation/useAnnouncementSeg'
import { Textarea } from '@jisr-hr/ds-beta'
import { Button, Flex } from '@jisr-hr/ds'
import ReactionsButton from './reactionsButton'

interface AnnouncementWidgetProps {
  item: any
  refetch: () => void
  sideDrawer?: boolean
  width?: number
}

const WidgetActionsButtons = ({ item, refetch, sideDrawer, width }: AnnouncementWidgetProps) => {
  const [showLeaveComment, setShowLeaveComment] = useState(false)
  const [commentText, setCommentText] = useState<string | null>(null)
  const { mutate: addComment } = useAddComment()
  const { mutate: markAsRead } = useMarkAnnouncementAsRead()

  const handleMarkAsRead = () => {
    markAsRead(
      { id: item.id },
      {
        onSuccess: () => {
          refetch()
        },
      },
    )
  }
  const handleLeaveComment = () => {
    addComment(
      {
        comment: {
          commentable_type: 'Announcement',
          commentable_id: item.announcement.id,
          content: commentText,
        },
      },
      {
        onSuccess: () => {
          setShowLeaveComment(false)
          setCommentText('')
        },
      },
    )
  }

  return (
    <>
      <Flex
        justifyBetween
        className="gap-2"
        flexCol={item.announcement?.allow_comment && !sideDrawer && true}
      >
        {!item.is_read && (
          <Flex className="gap-2 w-full">
            <Button
              label={i18n.t('action.mark_as_read')}
              leadingIcon="check"
              variant="outlined"
              fullWidth
              size="small"
              color="primary"
              onClick={() => {
                handleMarkAsRead()
              }}
            />
          </Flex>
        )}
        <Flex className="gap-2 w-full">
          <ReactionsButton
            refetch={refetch}
            item={item.announcement}
            width={width}
          />
          {item.announcement?.allow_comment && (
            <Button
              label={i18n.t('action.leave_comment')}
              leadingIcon="message-square-02"
              variant="tinted"
              color="neutral"
              fullWidth
              size="small"
              onClick={() => {
                setShowLeaveComment(true)
              }}
            />
          )}
        </Flex>
      </Flex>
      {showLeaveComment && (
        <Flex
          flexCol
          className="gap-2"
        >
          <Textarea
            onChange={(value) => setCommentText(value)}
            value={commentText || ''}
            height={38}
            resizable
          />
          <Flex
            justifyBetween
            className="gap-2"
          >
            <Button
              label={i18n.t('cancel')}
              color="neutral"
              variant="outlined"
              size="small"
              onClick={() => setShowLeaveComment(false)}
              fullWidth
            />
            <Button
              label={i18n.t('action.publish_comment')}
              color="primary"
              variant="filled"
              size="small"
              fullWidth
              disabled={!commentText || commentText.replace(/ /g, '') === ''}
              onClick={() => handleLeaveComment()}
            />
          </Flex>
        </Flex>
      )}
    </>
  )
}
export default WidgetActionsButtons
